module.exports = __webpack_public_path__ + "static/leftsidebar-skeleton-a7080e76f7eadb98a657d60e0cad48dd.jpg";